import { RouteLocationNormalized } from 'vue-router'

import { AppStateEnum } from '@/enums'
import { GlobalState } from '@/store/modules/global/state'

import {
  SET_MINI,
  SET_IS_PENDO_LOADED,
  SET_APP_STATE,
  SET_HOME_LAYOUT,
  SET_PROJECT_LAYOUT,
  SET_TOGGLE_PROJECT_DRAWER,
  SET_NAVIGATION_DRAWER_PROFILE,
  SET_BADGE_PROFILE_VISIBLE,
  SET_ROUTER_HISTORY,
} from './mutation_types'

export const mutations = {
  [SET_APP_STATE] (state: GlobalState, value: AppStateEnum) {
    state.appState = value
  },
  [SET_IS_PENDO_LOADED] (state: GlobalState, value: boolean) {
    state.isPendoLoaded = value
  },
  [SET_MINI] (state: GlobalState, value: boolean) {
    state.mini = value
  },
  [SET_HOME_LAYOUT] (state: GlobalState, value: boolean) {
    state.homeLayout = value
  },
  [SET_PROJECT_LAYOUT] (state: GlobalState, value: boolean) {
    state.projectLayout = value
  },
  [SET_TOGGLE_PROJECT_DRAWER] (state: GlobalState, value: boolean) {
    state.toggleProjectDrawer = value
  },
  [SET_NAVIGATION_DRAWER_PROFILE] (state: GlobalState, value: boolean) {
    state.navigationDrawerProfile = value
  },
  [SET_BADGE_PROFILE_VISIBLE] (state: GlobalState, value: boolean) {
    state.badgeProfileVisible = value
  },
  [SET_ROUTER_HISTORY] (state: GlobalState, value: RouteLocationNormalized) {
    state.routerHistory.push(value)
  },
}
